import SortingModel from "@/store/entities/sortingmodel";

export default class  PagedFilterAndSortedRequest{
    maxResultCount:number;
    skipCount:number;
    where:string;
    keyWord: string;
    sorting: SortingModel[]
}